import { FC } from 'react'
import { Web3Modal } from '@web3modal/react'
import Web3Service from 'primsell-shared-layer/core/services/web3'

const Web3ModalProvider: FC = () =>
  Web3Service.walletConnect.modalConfig && <Web3Modal {...Web3Service.walletConnect.modalConfig} />

export { Web3ModalProvider }
